<!--<c-footer>-->
  <div style="display: none;" class="ms-auto">
    Created by
    <a href="https://adeelrana.com" target="_blank">
      <span> Adeel Rana</span>
    </a>
  </div>
<!--</c-footer>-->
